module.exports = __webpack_public_path__ + "static/media/hand_lettered_concept_for_bakery_sign_2020.99c670b4.webp";